import React from "react";
import { HiOutlineMail } from "react-icons/hi";
import { SiLeetcode } from "react-icons/si";
import Fiverr from "../../assets/logo/fiverr.png";
import { FaGithub, FaLinkedin } from "react-icons/fa";
const SocialIcons = () => {
  return (
    <div className="hidden lg:flex fixed flex-col top-[35%] left-0">
      <ul>
        <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-500">
          <a
            href="https://www.linkedin.com/in/ahmaddin-samir-240b68aa/"
            target="_blank"
            className="flex items-center justify-between w-full text-gray-300"
          >
            Linkedin <FaLinkedin size={30}></FaLinkedin>
          </a>
        </li>
        <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]">
          <a
            href="https://github.com/SamirAhma"
            target="_blank"
            className="flex items-center justify-between w-full text-gray-300"
          >
            Github <FaGithub size={30}></FaGithub>
          </a>
        </li>
        <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#ffa116]">
          <a
            href="https://leetcode.com/samir1234/"
            className="flex items-center justify-between w-full text-gray-300"
          >
            Leetcode <SiLeetcode size={30}></SiLeetcode>
          </a>
        </li>
        <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#00b12b]">
          <a
            href="https://fiverr.com/ahmaddin381"
            target="_blank"
            className="flex items-center justify-between w-full text-gray-300"
          >
            Fiverr <img src={Fiverr} width={30} />
          </a>
        </li>
        <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]">
          <a
            href="mailto:ahmaddin1000@gmail.com"
            className="flex items-center justify-between w-full text-gray-300"
          >
            Email <HiOutlineMail size={30}></HiOutlineMail>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialIcons;
